<template>
  <v-container fluid class="pt-3">
    <v-card class="elevation-0 shadow-md white mt-2 flex xs12 px-2">
      <v-card-title primary-title class="subheading body-2">
        <strong v-if="!readonly">{{ $t("individual_cif_title") }}</strong>
        <strong v-else>{{ $t("customer_details") }}: </strong>
        <v-divider class="mx-2" />
        <v-btn
          icon
          flat
          v-if="customer.id"
          color="grey darken-2"
          :to="`/print/individuals/${customer.id}`"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          icon
          flat
          color="grey darken-2"
          v-if="customer.id && readonly && canEdit"
          :to="`/individuals/edit/${customer.id}`"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <!-- <v-btn class="mx-0" @click="save" :loading="loading" color="primary">
          <v-icon class="mx-2" left>check</v-icon>
          <strong class="mt-1">
            {{ $t("save") }}
          </strong>
        </v-btn> -->
      </v-card-title>
      <v-card-text class="pt-3">
        <v-form>
          <v-layout row wrap justify-space-between>
            <div class="flex xs12 md2" style="max-width: 220px">
              <customer-image
                :readonly="readonly"
                :file="customer.individual.photo"
                v-model="customer.individual.image"
              />
              <!-- :src="customer.individual.photo" -->
              <div class="mt-2 subheading font-weight-bold">
                {{ $t("reg") }}: #{{ customer.id }}
              </div>
            </div>

            <v-flex xs12 md6>
              <v-container fluid class="">
                <v-layout row wrap class="justify-center">
                  <v-flex
                    xs12
                    class="di-flex align-center justify-space-between"
                  >
                    <div class="caption">
                      <strong>{{ $t("files") }}</strong>
                      <br />
                      {{ $t("file_max_notation") }}
                    </div>
                    <file-chooser
                      text
                      color="secondary"
                      v-show="!readonly"
                      v-model="customer.files"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    v-if="customer.files && customer.files.length > 0"
                    class="mt-3"
                  >
                    <file-viewer :files="customer.files" />
                  </v-flex>
                </v-layout>
              </v-container>
              <v-divider class="flex xs12"></v-divider>
            </v-flex>
          </v-layout>

          <!-- Personal Details -->
          <v-layout row wrap class="mt-5">
            <div class="flex xs12 di-flex align-center mb-5 body-2">
              <strong class="body-2">{{ $t("personal_details") }}</strong>
              <v-spacer />
              <!-- <v-checkbox
                hide-details
                class="flex xs12 md4"
                :label="$t('temporary')"
                v-model="customer.individual.temporary"
              /> -->
            </div>

            <v-flex xs12 class="px-2">
              <v-layout row wrap class="pa-0 mb-2">
                <v-autocomplete
                  outline
                  placeholder=" "
                  :items="states"
                  item-value="id"
                  :readonly="readonly"
                  class="flex xs12 md3"
                  :label="$t('status')"
                  v-model="customer.individual.temporary"
                />
                <!-- nature_of_busines_types -->
                <!-- :items="['Money Service Provider', 'Foreign exchange dealer', 'Business income']" -->
                <div class="mx-2"></div>
                <v-checkbox
                  :label="$t('sanction_screening')"
                  v-model="customer.individual.sanction_screening"
                />
              </v-layout>
            </v-flex>

            <v-flex xs12 md3 class="px-2">
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                v-validate="'required'"
                :label="$t('first_name')"
                data-vv-name="first_name"
                :data-vv-as="$t('first_name')"
                v-model="customer.individual.first_name"
                :error-messages="errors.collect('first_name')"
              />
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('middle_name')"
                v-model="customer.individual.middle_name"
              />
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('last_name')"
                v-model="customer.individual.last_name"
              />
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('father_name')"
                v-model="customer.individual.father_name"
              />
            </v-flex>
            <v-flex xs12 md3 class="px-2">
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                :readonly="readonly"
                :label="$t('place_of_birth')"
                v-model="customer.individual.place_of_birth"
              />
              <v-date
                class="py-0"
                :editable="true"
                :has-icon="true"
                format="YYYY-MM-DD"
                :readonly="readonly"
                :single-line="false"
                value-type="YYYY-MM-DD"
                input_id="date_of_birth"
                :placeholder="$t('date_of_birth')"
                v-model="customer.individual.date_of_birth"
              />
              <v-combobox
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('gender')"
                :items="['Male', 'Female']"
                v-model="customer.individual.gender"
              />
              <div class="mx-1" />
              <v-combobox
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('marital_status')"
                :items="['Married', 'Single']"
                v-model="customer.individual.marital_status"
              />
            </v-flex>

            <v-flex xs12 md4 class="px-2">
              <v-date
                :editable="true"
                :has-icon="true"
                format="YYYY-MM-DD"
                input_id="reg_date"
                :readonly="readonly"
                :single-line="false"
                value-type="YYYY-MM-DD"
                :placeholder="$t('reg_date')"
                v-model="customer.individual.reg_date"
              />
              <v-textarea
                outline
                auto-grow
                rows="0"
                class="mt-4"
                placeholder=" "
                :readonly="readonly"
                :label="$t('current_address')"
                v-model="customer.individual.current_address"
              />
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                :readonly="readonly"
                :label="$t('permanent_address')"
                v-model="customer.individual.permanent_address"
              />

              <div class="di-flex justify-start align-end mb-3 pb-">
                <v-radio-group
                  row
                  placeholder=" "
                  :readonly="readonly"
                  v-model="customer.individual.resident"
                >
                  <v-radio
                    dense
                    class="m"
                    value="resident"
                    :label="$t('resident')"
                  ></v-radio>
                  <v-radio
                    dense
                    class="m"
                    value="non-resident"
                    :label="$t('non_resident')"
                  ></v-radio>
                </v-radio-group>
              </div>
            </v-flex>
          </v-layout>
          <!-- ENd OF Personal Details -->

          <!-- phones Details -->
          <v-layout row wrap class="mt-3">
            <v-flex xs12 md5 class="px-2">
              <v-layout column>
                <v-radio-group
                  row
                  class="mb-4"
                  :readonly="readonly"
                  v-model="customer.individual.doctype"
                >
                  <v-radio label="Passport" value="passport"></v-radio>
                  <v-radio label="Tazkira" value="tazkira"></v-radio>
                  <v-radio :label="$t('gov_id')" value="govid"></v-radio>
                </v-radio-group>
                <v-textarea
                  outline
                  rows="0"
                  auto-grow
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('nationality')"
                  v-model="customer.individual.nationality"
                  v-if="customer.individual.doctype != 'govid'"
                />
                <v-layout v-if="isTazkira">
                  <v-text-field
                    outline
                    placeholder=" "
                    :readonly="readonly"
                    :label="$t('tazkira_no')"
                    v-model="customer.individual.tazkira_no"
                  />
                  <div class="mx-1" />
                  <v-text-field
                    outline
                    placeholder=" "
                    :readonly="readonly"
                    :label="$t('issuer_place')"
                    v-model="customer.individual.issuer_place"
                  />
                </v-layout>
                <v-layout v-if="customer.individual.doctype == 'govid'">
                  <v-text-field
                    outline
                    placeholder=" "
                    :readonly="readonly"
                    :label="$t('gov_id')"
                    v-model="customer.individual.gov_id"
                  />
                </v-layout>
                <v-layout v-if="customer.individual.doctype == 'passport'">
                  <v-text-field
                    outline
                    placeholder=" "
                    :readonly="readonly"
                    :label="$t('passport_no')"
                    v-model="customer.individual.passport_no"
                  />
                  <div class="mx-1" />
                  <v-text-field
                    outline
                    placeholder=" "
                    :readonly="readonly"
                    :label="$t('issuer_place')"
                    v-model="customer.individual.issuer_place"
                  />
                </v-layout>
                <div
                  class="di-flex flex"
                  v-if="customer.individual.doctype == 'passport'"
                >
                  <v-date
                    class="flex"
                    :has-icon="true"
                    :readonly="readonly"
                    :single-line="false"
                    input_id="issue_date"
                    :placeholder="$t('issue_date')"
                    v-model="customer.individual.issue_date"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                  />
                  <div class="mx-1" />
                  <v-date
                    class="flex"
                    :has-icon="true"
                    :readonly="readonly"
                    :single-line="false"
                    input_id="expire_date"
                    :placeholder="$t('expire_date')"
                    v-model="customer.individual.expire_date"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                  />
                </div>
              </v-layout>
            </v-flex>
            <v-flex xs12 md5 class="px-2">
              <div class="di-flex align-center mb-5">
                <strong class="body-2">{{ $t("contact_details") }}</strong>
              </div>
              <v-combobox
                outline
                multiple
                small-chips
                placeholder=" "
                :readonly="readonly"
                :label="$t('phones')"
                v-model="customer.individual.phones"
              />
              <v-text-field
                outline
                placeholder=" "
                :label="$t('email')"
                :readonly="readonly"
                v-model="customer.individual.email"
              />
              <v-combobox
                outline
                cache-items
                placeholder=" "
                :readonly="readonly"
                :label="$t('customer_type')"
                v-model="customer.individual.customer_type"
                :items="['Salary Based', 'Rent Income', 'Business income']"
              />
            </v-flex>
          </v-layout>
          <!-- End of phones Details -->

          <!-- profession details -->
          <v-layout row wrap class="mt-3">
            <v-flex xs12 md5 class="px-2">
              <div class="di-flex align-center mb-5">
                <strong class="body-2">{{ $t("profession_details") }}</strong>
              </div>
              <!-- <div class="di-flex">
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('business_name')"
                  v-model="customer.individual.business_name"
                />
                <div class="mx-2"></div>
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('nature_of_business')"
                  v-model="customer.individual.nature_of_business"
                />
              </div> -->

              <v-layout row>
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('source_of_income')"
                  v-model="customer.individual.source_of_income"
                />
                <div class="mx-2" />
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('monthly_income')"
                  v-model="customer.individual.monthly_income"
                />
              </v-layout>
              <div class="di-flex">
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('monthly_turnover')"
                  v-model="customer.individual.monthly_turnover"
                />

                <div class="mx-2"></div>
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('tin_number')"
                  v-model="customer.individual.tin_number"
                />
              </div>
              <div class="di-flex">
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('tenure')"
                  v-model="customer.individual.tenure"
                />
                <div class="mx-2"></div>
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('current_designation')"
                  v-model="customer.individual.current_designation"
                />
              </div>
              <v-date
                class="flex"
                :has-icon="true"
                format="YYYY-MM-DD"
                :readonly="readonly"
                :single-line="false"
                value-type="YYYY-MM-DD"
                input_id="establishment_date"
                :placeholder="$t('establishment_date')"
                v-model="customer.individual.establishment_date"
              />
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                :readonly="readonly"
                :label="$t('official_address')"
                v-model="customer.individual.official_address"
              />
              <v-textarea
                outline
                auto-grow
                placeholder=" "
                :readonly="readonly"
                :label="$t('previous_designation')"
                v-model="customer.individual.previous_designation"
              />
            </v-flex>
            <v-flex xs12 md5 class="px-2">
              <div class="di-flex align-center mb-5">
                <strong class="body-2">{{ $t("kyc_notes") }}</strong>
              </div>

              <v-layout row>
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('source_of_fund')"
                  v-model="customer.individual.source_of_fund"
                />
                <div class="mx-2" />
                <v-text-field
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('occupation')"
                  v-model="customer.individual.occupation"
                />
              </v-layout>
              <div class="di-flex">
                <v-combobox
                  outline
                  placeholder=" "
                  :readonly="readonly"
                  :label="$t('risk_profile')"
                  :items="['High', 'Medium', 'Low']"
                  v-model="customer.individual.risk_profile"
                />
              </div>
              <v-textarea
                outline
                auto-grow
                placeholder=" "
                :readonly="readonly"
                :label="$t('kyc_notes')"
                v-model="customer.individual.kyc_notes"
              />
              <v-layout row wrap>
                <v-date
                  :has-icon="true"
                  format="YYYY-MM-DD"
                  :readonly="readonly"
                  :single-line="false"
                  value-type="YYYY-MM-DD"
                  @input="setNextKycDate"
                  class="flex xs12 md6 px-1"
                  input_id="kyc_updated_date"
                  :placeholder="$t('kyc_updated_date')"
                  v-model="customer.individual.kyc_updated_date"
                />
                <!-- <div class="mx-1" /> -->
                <v-date
                  class="flex xs12 md6 px-1"
                  :has-icon="true"
                  :readonly="readonly"
                  :single-line="false"
                  input_id="next_kyc_date"
                  :placeholder="$t('next_kyc_date')"
                  v-model="customer.individual.next_kyc_date"
                  format="YYYY-MM-DD"
                  value-type="YYYY-MM-DD"
                />
              </v-layout>
              <v-layout row wrap>
                <v-checkbox
                  :label="$t('pep')"
                  class="flex xs12 md4"
                  v-model="customer.individual.pep"
                />
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- end of profession details -->

          <v-divider class="mx-3 my-2" />
          <v-flex xs12 class="di-flex justify-end">
            <v-btn
              class="mx-0"
              @click="save"
              color="primary"
              v-if="!readonly"
              :loading="loading"
            >
              <v-icon class="mx-2" left>check</v-icon>
              <strong class="mt-1">
                {{ $t("save") }}
              </strong>
            </v-btn>
          </v-flex>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";
let currentDate = new Date();
currentDate.setFullYear(currentDate.getFullYear() + 1);
export default {
  name: "IndividualReg",
  props: {
    value: {
      default: () => ({
        files: [],
        details: {},
      }),
    },
    readonly: {
      default: false,
    },
  },
  data: () => ({
    loading: false,
    customer: {
      files: [],
      is_bank: false,
      type: "individual",
      individual: {
        first_name: "",
        middle_name: "",
        last_name: "",
        father_name: "",
        date_of_birth: null,
        place_of_birth: "",
        gender: "Male",
        photo: require("@/assets/images/userplaceholder.svg"),
        image: require("@/assets/images/userplaceholder.svg"),
        marital_status: "Single",
        current_address: "",
        permanent_address: "",
        resident: "resident",
        doctype: "passport",
        nationality: "Afghan",
        tazkira_no: "",
        passport_no: "",
        issuer_place: "",
        issue_date: "",
        expire_date: "",
        phones: null,
        email: "",
        nature_of_business: "",
        source_of_income: "",
        monthly_income: "",
        monthly_turnover: "",
        tin_number: "",
        tenure: "",
        risk_profile: "",
        kyc_notes: " ",
        reg_date: new Date().toLocaleDateString("en-ca"),
        kyc_updated_date: new Date().toLocaleDateString("en-ca"),
        next_kyc_date: currentDate.toLocaleDateString("en-ca"),
        current_designation: "",
        previous_designation: "",
        official_address: "",
        sanction_screening: false,
        is_pep: false,
        temporary: 0, //permanet
      },
    },
  }),
  mixins: [customersMixin],
  computed: {
    canEdit() {
      return this.userCan("edit_individuals");
    },
    isTazkira() {
      return this.customer.individual.doctype == "tazkira";
    },
    fullName() {
      let details = this.customer.individual;
      return (
        details.first_name +
        " " +
        (details.middle_name ? details.middle_name : "") +
        " " +
        (details.last_name ? details.last_name : "")
      );
    },
    states() {
      return [
        { id: 1, text: this.$t("temporary") },
        { id: 0, text: this.$t("permanent") },
      ];
    },
  },
  methods: {
    setNextKycDate() {
      let currentDate = new Date(this.customer.individual.kyc_updated_date);
      currentDate.setFullYear(currentDate.getFullYear() + 1);
      this.customer.individual.next_kyc_date = currentDate
        .toLocaleDateString("en-ca");
    },
    async uploadImage(file, id, type) {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("id", id);
      await this.axios.post("setPhoto", fd);
    },

    async save() {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          this.customer.name = this.fullName;
          this.axios
            .post("customers", this.customer)
            .then(async (res) => {
              let fils = this.customer.files.filter((x) => !x.id);
              if (fils.length > 0) {
                const fd = new FormData();
                fd.append("fileable_type", "Customer");
                fd.append("fileable_id", res.data.data.id);
                for (const file of fils) {
                  fd.append("files[]", file);
                }
                await this.axios.post("files", fd, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });
              }
              this.loading = false;
              this.customer.id = res.data.data.id;
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true,
              });

              this.getCustomers();
              this.$router.replace(`/print/individuals/${res.data.data.id}`);
              this.$emit("saved", res.data.data);
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
            });
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
        }
      });
    },
  },
  watch: {
    value: function () {
      this.customer = this.value;
      this.$emit("input", this.value);
    },
  },
  created() {
    let id = this.$store.state.route.params.id;
    if (this.readonly) {
      this.customer = this.value;
    } else if (id) {
      this.axios
        .get(`customers/${id}?type=individual`)
        .then((response) => {
          this.customer = response.data.data;
          this.correct_route = true;
          this.loading = false;
        })
        .catch((error) => {
          this.correct_route = false;
          this.loading = false;
        });
    }
  },
};
</script>
<style >
.reg_customer_image {
  width: 150px !important;
  height: 200px !important;
  background-color: #e2e2e2;
  border: 1px solid #a0a0a0 !important;
}
</style>